export function aarhusguidenConstructCard(event, targetContainer, url){
    /* const container = document.querySelector(`.${targetContainer}`).querySelector('.row'); */
    //construct card
    let col = document.createElement('div');
    col.classList.add('col-md-6', 'col-lg-4');

    // Create the outer <a> element
    let eventCard = document.createElement('a');
    eventCard.classList.add('card', 'card__event', 'bg--surface');

    eventCard.setAttribute('href', `${url}?id=${event.event.entityId}`);

    // Create the <div> element for the image content
    let imageContentDiv = document.createElement('div');
    imageContentDiv.classList.add('card__event__image-content');
    eventCard.appendChild(imageContentDiv);

    
    //Only create image if image url
    if(event.event.imageUrls){
      
      // Create the nested <div> for the image content container
      let imageContentContainerDiv = document.createElement('div');
      imageContentContainerDiv.classList.add('card__event__image-content--container');
      imageContentDiv.appendChild(imageContentContainerDiv);
      
      // Create the nested <div> for the image
      let imageDiv = document.createElement('div');
      imageDiv.classList.add('card__event__image-content__image');
      imageContentContainerDiv.appendChild(imageDiv);
      
      // Create the <img> element for the image
      let image = document.createElement('img');
      image.classList.add('ls-is-cached', 'lazyloaded');
      image.setAttribute('data-src', event.event.imageUrls.small);
      image.setAttribute('alt', 'Event billede');
      image.setAttribute('src', event.event.imageUrls.small);
      imageDiv.appendChild(image);
      
      // Create the nested <div> for the date
      let dateDiv = document.createElement('div');
      dateDiv.classList.add('card__event__image-content__date');
      imageContentDiv.appendChild(dateDiv);
      
      // Create the <p> elements for the date
      let day = document.createElement('p');
      day.classList.add('day');
      day.textContent = `${event.start.substring(8,10)}.`;
      dateDiv.appendChild(day);
      
      let month = document.createElement('p');
      month.classList.add('month');
      let monthSubstring = parseInt(event.start.substring(5,7))
      let months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.']
      month.textContent = months[monthSubstring - 1];
      dateDiv.appendChild(month);
      

    }

    // Create the <div> element for the event content
    let contentDiv = document.createElement('div');
    contentDiv.classList.add('card__event__content');
    eventCard.appendChild(contentDiv);

    // Create the <div> element for the text content
    let textDiv = document.createElement('div');
    textDiv.classList.add('card__event__content__text');
    contentDiv.appendChild(textDiv);

    // Create the <h3> element for the title
    let title = document.createElement('h3');
    title.textContent = event.event.title;
    textDiv.appendChild(title);

    // Create the <p> element for the description
    let description = document.createElement('p');
    description.textContent = event.event.excerpt
    textDiv.appendChild(description);

      // Create the <div> element for the icon list
    let listIconsDiv = document.createElement('div');
    listIconsDiv.classList.add('list__icons', 'list--dividers');
    contentDiv.appendChild(listIconsDiv);

    // Create the <ul> element for the icon list
    let ul = document.createElement('ul');
    
    // Create date li
    let liDate = document.createElement('li');
    
    // Create an SVG element
    let dateSvg = document.createElement('svg');
    dateSvg.classList.add('svg-date');
    dateSvg.setAttribute('width', '19');
    dateSvg.setAttribute('height', '21');
    dateSvg.setAttribute('viewBox', '0 0 19 21');
    dateSvg.setAttribute('fill', 'none');
    dateSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    
    // Create and append a <path> element to the SVG
    let path = document.createElement('path');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('clip-rule', 'evenodd');
    path.setAttribute('d', 'M3.04545 4.38635C2.31421 4.38635 1.75 4.95057 1.75 5.68181V17.9545C1.75 18.6858 2.31421 19.25 3.04545 19.25H15.3182C16.0494 19.25 16.6136 18.6858 16.6136 17.9545V5.68181C16.6136 4.95057 16.0494 4.38635 15.3182 4.38635H3.04545ZM0.25 5.68181C0.25 4.12214 1.48579 2.88635 3.04545 2.88635H15.3182C16.8778 2.88635 18.1136 4.12214 18.1136 5.68181V17.9545C18.1136 19.5142 16.8778 20.75 15.3182 20.75H3.04545C1.48579 20.75 0.25 19.5142 0.25 17.9545V5.68181Z');
    path.setAttribute('fill', '#000');
    dateSvg.appendChild(path);
    
    // Create and append a <rect> element to the SVG
    let rect = document.createElement('rect');
    rect.setAttribute('x', '1');
    rect.setAttribute('y', '4');
    rect.setAttribute('width', '16');
    rect.setAttribute('height', '6');
    rect.setAttribute('fill', '#000');
    dateSvg.appendChild(rect);
    
    // Create and append a <path> element to the SVG
    let path2 = document.createElement('path');
    path2.setAttribute('fill-rule', 'evenodd');
    path2.setAttribute('clip-rule', 'evenodd');
    path2.setAttribute('d', 'M4.27246 0.25C4.68667 0.25 5.02246 0.585786 5.02246 1V4.27273C5.02246 4.68694 4.68667 5.02273 4.27246 5.02273C3.85825 5.02273 3.52246 4.68694 3.52246 4.27273V1C3.52246 0.585786 3.85825 0.25 4.27246 0.25Z');
    path2.setAttribute('fill', '#000');
    dateSvg.appendChild(path2);

    // Create and append a <path> element to the SVG
    let path3 = document.createElement('path');
    path3.setAttribute('fill-rule', 'evenodd');
    path3.setAttribute('clip-rule', 'evenodd');
    path3.setAttribute('d', 'M14.0908 0.25C14.505 0.25 14.8408 0.585786 14.8408 1V4.27273C14.8408 4.68694 14.505 5.02273 14.0908 5.02273C13.6766 5.02273 13.3408 4.68694 13.3408 4.27273V1C13.3408 0.585786 13.6766 0.25 14.0908 0.25Z');
    path3.setAttribute('fill', '#000');
    dateSvg.appendChild(path3);

    liDate.appendChild(dateSvg)
    let month = document.createElement('p');
    let months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.']
    //if only one date

    let monthSubstring = parseInt(event.start.substring(5,7))
    liDate.innerHTML += `${event.start.substring(8,10)}. ${month.textContent = months[monthSubstring - 1]} ${event.start.substring(0, 4)}`

 
    ul.appendChild(liDate)

    // Create time li
    let liTime = document.createElement('li');

    // Create time svg
    let timeSvg = document.createElement('svg');
    timeSvg.classList.add('svg-time');
    timeSvg.setAttribute('width', '19')
    timeSvg.setAttribute('height', '19')
    timeSvg.setAttribute('viewBox', '0 0 19 19')
    timeSvg.setAttribute('fill', 'none')
    timeSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    let timeCircle = document.createElement('circle');
    timeCircle.setAttribute('cx', '9.5')
    timeCircle.setAttribute('cy', '9.5')
    timeCircle.setAttribute('r', '8.75')
    timeCircle.setAttribute('stroke', '#000')
    timeCircle.setAttribute('stroke-width', '1.5')
    timeSvg.appendChild(timeCircle)

    let timePath = document.createElement('path')
    timePath.setAttribute('d', 'M9.02539 4.27502V10.45L11.8754 13.3')
    timePath.setAttribute('stroke', '#000')
    timePath.setAttribute('stroke-width', '1.5')
    timeSvg.appendChild(timePath)

    liTime.appendChild(timeSvg);

    //get times
    let startTime = event.start.substring(11, 16).replace(':','.')
    let endTime = event.end.substring(11, 16).replace(':','.')
    if(startTime == '00.00' && endTime == '23.59'){
      liTime.innerHTML += 'Hele dagen'
    } else {
      liTime.innerHTML += `${startTime} - ${endTime}`
    }

    ul.appendChild(liTime)

    // Create location li
    let liLocation = document.createElement('li');

    //Create locationSvg
    let locationSvg = document.createElement('svg');
    locationSvg.classList.add('svg-location');
    locationSvg.setAttribute('width', '16')
    locationSvg.setAttribute('height', '21')
    locationSvg.setAttribute('viewBox', '0 0 16 21')
    locationSvg.setAttribute('fill', 'none')
    locationSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')

    let locationPath = document.createElement('path');
    locationPath.setAttribute('d', 'M8 0C3.6 0 0 3.6 0 8C0 9.73333 0.533333 11.4 1.6 12.8L8 21L14.4 12.8C15.4667 11.4 16 9.73333 16 8C16 3.6 12.4 0 8 0ZM8 10.8667C6.26667 10.8667 4.8 9.46667 4.8 7.66667C4.8 6 6.26667 4.53333 8 4.53333C9.73333 4.53333 11.2 5.93333 11.2 7.73333C11.2 9.46667 9.73333 10.8667 8 10.8667Z')
    locationPath.setAttribute('fill', '#000')
    locationSvg.appendChild(locationPath)

    liLocation.appendChild(locationSvg)
    liLocation.innerHTML += `${event.event.location ? event.event.location.name : ''}`

    ul.appendChild(liLocation)

    listIconsDiv.appendChild(ul);


    
    //append to dom
    col.appendChild(eventCard);
    
    targetContainer.appendChild(col)
    

}

export default aarhusguidenConstructCard

